import { useState } from "react";

const categories = [
  {
    id: 1,
    title: "Marathi Bhajans & Aarti",
    subtitle: "दिगंबर जैन अभिषेक-विधान पूजा-भावभक्तिगीत-स्तोत्र - संवाद गीत-मंत्र-समता माला",
    count: "500+",
    color: "#c0392b",
    accentColor: "#e74c3c",
    gradient: "linear-gradient(135deg, #7b1a1a 0%, #c0392b 50%, #922b21 100%)",
    badge: "स्वरमागरासृत",
    badgeSub: "मराठी भजन आणि आरती",
    emoji: "🙏",
    highlight: "#f39c12",
  },
  {
    id: 2,
    title: "Hindi Bhajans & Songs",
    subtitle: "हिंदी भजन एवं गीत - स्तोत्र - संवाद गीत - मंत्र - समता माला",
    count: "800+",
    color: "#8e44ad",
    accentColor: "#9b59b6",
    gradient: "linear-gradient(135deg, #4a1a5c 0%, #8e44ad 50%, #6c3483 100%)",
    badge: "स्वरमागरासृत",
    badgeSub: "हिंदी भजन आणि गीत",
    emoji: "🕉️",
    highlight: "#e74c3c",
  },
  {
    id: 3,
    title: "Kannada Bhajans & Songs",
    subtitle: "ಕನ್ನಡ ಭಜನೆ ಮತ್ತು ಹಾಡುಗಳು - ಸ್ತೋತ್ರ - ಮಂತ್ರ",
    count: "300+",
    color: "#d4a017",
    accentColor: "#f39c12",
    gradient: "linear-gradient(135deg, #7d5a0a 0%, #c8860a 50%, #9a6708 100%)",
    badge: "ಸ್ವರಮಾಗರಾಸೃತ",
    badgeSub: "ಕನ್ನಡ ಭಜನ ಆಣಿ ಗೀತ",
    emoji: "✨",
    highlight: "#e67e22",
  },
  {
    id: 4,
    title: "Gorakshanath Bhajans",
    subtitle: "दिगंबर जैन अभिषेक-विधान पूजा-भावभक्तिगीत-स्तोत्र - संवाद गीत-मंत्र",
    count: "200+",
    color: "#1a6b3c",
    accentColor: "#27ae60",
    gradient: "linear-gradient(135deg, #0d3d22 0%, #1a6b3c 50%, #145a32 100%)",
    badge: "स्वरमागरासृत",
    badgeSub: "गोरक्षनाथ भजन",
    emoji: "🌸",
    highlight: "#f1c40f",
  },
];

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
    <path d="M8 5v14l11-7z" />
  </svg>
);

const MusicNote = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14" style={{ opacity: 0.6 }}>
    <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
  </svg>
);

export default function CategoryExplorer() {
  const [hovered, setHovered] = useState(null);
  const [playing, setPlaying] = useState(null);

  return (
    <div className="cat-page">
      <div className="orb orb1" />
      <div className="orb orb2" />
      <div className="grain" />

      <div className="cat-container">
        {/* Header */}
        <div className="cat-header">
          <span className="cat-eyebrow">EXPLORE BY</span>
          <h1 className="cat-title">CATEGORY</h1>
          <div className="cat-divider">
            <span className="divider-line" />
            <span className="divider-dot" />
            <span className="divider-line" />
          </div>
          <p className="cat-subtitle">
            विविध भाषांमधील भजन, आरती आणि आध्यात्मिक गीतांचा संग्रह
          </p>
        </div>

        {/* Cards Grid */}
        <div className="cat-grid">
          {categories.map((cat) => {
            const isHovered = hovered === cat.id;
            const isPlaying = playing === cat.id;

            return (
              <div
                key={cat.id}
                className={`cat-card ${isHovered ? "cat-card--hovered" : ""}`}
                onMouseEnter={() => setHovered(cat.id)}
                onMouseLeave={() => setHovered(null)}
                onTouchStart={() => setHovered(cat.id)}
                onTouchEnd={() => setHovered(null)}
              >
                {/* Dynamic inline styles only for per-card color values */}
                <div className="card-bg" style={{ background: cat.gradient }} />
                <div className="card-overlay" />

                <div className="corner-tl" />
                <div className="corner-br" />

                {/* Badge */}
                <div className="badge-wrap">
                  <div
                    className="badge"
                    style={{ borderColor: cat.highlight + "88" }}
                  >
                    <span className="badge-text" style={{ color: cat.highlight }}>
                      {cat.badge}
                    </span>
                  </div>
                </div>

                {/* Emoji */}
                <div className="emoji-wrap">
                  <span
                    className={`cat-emoji ${isHovered ? "cat-emoji--hovered" : ""}`}
                    style={{
                      filter: isHovered
                        ? `drop-shadow(0 0 12px ${cat.highlight})`
                        : "none",
                    }}
                  >
                    {cat.emoji}
                  </span>
                </div>

                {/* Language label */}
                <div className="lang-label" style={{ background: cat.highlight }}>
                  <MusicNote />
                  <span className="lang-text">{cat.badgeSub}</span>
                </div>

                {/* Bottom */}
                <div className="card-bottom">
                  <div>
                    <h3 className="card-title">{cat.title}</h3>
                    <p className="card-subtitle">{cat.subtitle}</p>
                  </div>

                  <div className="card-footer">
                    <span
                      className="count-badge"
                      style={{ background: cat.highlight }}
                    >
                      {cat.count} Songs
                    </span>
                    <button
                      className={`play-btn ${isHovered ? "play-btn--hovered" : ""} ${isPlaying ? "play-btn--playing" : ""}`}
                      style={{
                        background: cat.highlight,
                        boxShadow: isHovered ? `0 0 20px ${cat.highlight}88` : "none",
                      }}
                      onClick={() => setPlaying(isPlaying ? null : cat.id)}
                    >
                      <PlayIcon />
                    </button>
                  </div>
                </div>

                {/* Shimmer */}
                <div className={`shimmer ${isHovered ? "shimmer--visible" : ""}`} />
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@400;700;900&family=Noto+Sans+Devanagari:wght@400;500;700&family=Cinzel:wght@400;600;700&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes floatOrb {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33%       { transform: translate(30px, -20px) scale(1.05); }
          66%       { transform: translate(-20px, 15px) scale(0.97); }
        }
        @keyframes shimmerMove {
          0%   { background-position: -200% center; }
          100% { background-position:  200% center; }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── Page ── */
        .cat-page {
          min-height: 100vh;
          background: #1c100a;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'Noto Sans Devanagari', serif;
          padding: 60px 24px;
        }

        /* ── Orbs ── */
        .orb {
          position: absolute;
          border-radius: 50%;
          pointer-events: none;
        }
        .orb1 {
          top: -10%; left: -5%;
          width: 500px; height: 500px;
          background: radial-gradient(circle, #7b2d1044 0%, transparent 70%);
          animation: floatOrb 12s ease-in-out infinite;
        }
        .orb2 {
          bottom: -10%; right: -5%;
          width: 600px; height: 600px;
          background: radial-gradient(circle, #4a1a5c33 0%, transparent 70%);
          animation: floatOrb 15s ease-in-out infinite reverse;
        }
        .grain {
          position: absolute;
          inset: 0;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.03'/%3E%3C/svg%3E");
          pointer-events: none;
          opacity: 0.4;
        }

        /* ── Container ── */
        .cat-container {
          position: relative;
          z-index: 1;
          max-width: 1300px;
          width: 100%;
          animation: fadeInUp 0.8s ease both;
        }

        /* ── Header ── */
        .cat-header {
          text-align: center;
          margin-bottom: 56px;
        }
        .cat-eyebrow {
          display: inline-block;
          font-family: 'Cinzel', serif;
          font-size: 13px;
          letter-spacing: 6px;
          color: #d4a857;
          font-weight: 600;
          margin-bottom: 12px;
        }
        .cat-title {
          font-family: 'Cinzel Decorative', serif;
          font-size: clamp(32px, 6vw, 72px);
          font-weight: 900;
          color: #f5e6c8;
          letter-spacing: 4px;
          text-shadow: 0 4px 30px rgba(212,168,87,0.3);
          line-height: 1.1;
        }
        .cat-divider {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin: 18px auto;
          width: 200px;
        }
        .divider-line {
          flex: 1;
          height: 1px;
          background: linear-gradient(90deg, transparent, #d4a857, transparent);
        }
        .divider-dot {
          width: 6px; height: 6px;
          border-radius: 50%;
          background: #d4a857;
          flex-shrink: 0;
        }
        .cat-subtitle {
          font-family: 'Noto Sans Devanagari', sans-serif;
          font-size: 16px;
          color: #c4a882;
          letter-spacing: 0.5px;
          line-height: 1.6;
        }

        /* ── Grid ── */
        .cat-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }

        /* ── Card ── */
        .cat-card {
          position: relative;
          border-radius: 16px;
          overflow: hidden;
          cursor: pointer;
          transition:
            transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1),
            box-shadow 0.35s ease;
          min-height: 360px;
          display: flex;
          flex-direction: column;
          border: 1px solid rgba(255,255,255,0.06);
          box-shadow: 0 10px 30px rgba(0,0,0,0.4);
          transform: translateY(0) scale(1);
        }
        .cat-card--hovered {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 30px 60px rgba(0,0,0,0.5);
        }

        .card-bg {
          position: absolute;
          inset: 0;
          z-index: 0;
        }
        .card-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg,
            rgba(0,0,0,0.1) 0%,
            rgba(0,0,0,0.3) 40%,
            rgba(0,0,0,0.75) 100%);
          z-index: 1;
        }
        .corner-tl {
          position: absolute;
          top: 10px; left: 10px;
          width: 30px; height: 30px;
          border-top: 2px solid rgba(255,255,255,0.2);
          border-left: 2px solid rgba(255,255,255,0.2);
          border-radius: 4px 0 0 0;
          z-index: 4;
        }
        .corner-br {
          position: absolute;
          bottom: 10px; right: 10px;
          width: 30px; height: 30px;
          border-bottom: 2px solid rgba(255,255,255,0.2);
          border-right: 2px solid rgba(255,255,255,0.2);
          border-radius: 0 0 4px 0;
          z-index: 4;
        }

        /* Badge */
        .badge-wrap {
          position: relative;
          z-index: 3;
          padding: 16px 16px 0;
          display: flex;
          justify-content: center;
        }
        .badge {
          border: 2px solid;
          border-radius: 8px;
          padding: 5px 14px;
          backdrop-filter: blur(6px);
          background: rgba(0,0,0,0.3);
        }
        .badge-text {
          font-family: 'Cinzel', serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
        }

        /* Emoji */
        .emoji-wrap {
          position: relative;
          z-index: 3;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }
        .cat-emoji {
          font-size: 60px;
          transition:
            transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),
            filter 0.4s ease;
          display: block;
          line-height: 1;
          transform: scale(1) rotate(0deg);
        }
        .cat-emoji--hovered {
          transform: scale(1.15) rotate(5deg);
        }

        /* Lang label */
        .lang-label {
          position: relative;
          z-index: 3;
          margin: 0 16px 12px;
          border-radius: 8px;
          padding: 6px 12px;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .lang-text {
          font-family: 'Noto Sans Devanagari', sans-serif;
          font-size: 12px;
          font-weight: 700;
          color: #1c100a;
          letter-spacing: 0.3px;
        }

        /* Card bottom */
        .card-bottom {
          position: relative;
          z-index: 3;
          padding: 0 16px 16px;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .card-title {
          font-family: 'Cinzel', serif;
          font-size: 14px;
          font-weight: 700;
          color: #f5e6c8;
          line-height: 1.3;
          margin-bottom: 4px;
        }
        .card-subtitle {
          font-family: 'Noto Sans Devanagari', sans-serif;
          font-size: 10px;
          color: rgba(245,230,200,0.55);
          line-height: 1.5;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .card-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .count-badge {
          font-family: 'Cinzel', serif;
          font-size: 11px;
          font-weight: 700;
          color: #1c100a;
          padding: 4px 12px;
          border-radius: 20px;
          letter-spacing: 0.5px;
        }
        .play-btn {
          width: 42px; height: 42px;
          border-radius: 50%;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #1c100a;
          transition:
            transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1),
            box-shadow 0.3s ease;
          padding-left: 3px;
          transform: scale(1);
        }
        .play-btn--hovered  { transform: scale(1.1); }
        .play-btn--playing  { transform: scale(0.9); }

        /* Shimmer */
        .shimmer {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            105deg,
            transparent 40%,
            rgba(255,255,255,0.06) 50%,
            transparent 60%
          );
          background-size: 200% 100%;
          animation: shimmerMove 1.5s ease-in-out infinite;
          z-index: 5;
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .shimmer--visible { opacity: 1; }

        /* ════════════════════════════════════
           RESPONSIVE BREAKPOINTS
        ════════════════════════════════════ */

        /* ── Tablet: 900px – 1100px — 2×2 grid ── */
        @media (max-width: 1100px) {
          .cat-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 18px;
          }
          .cat-card {
            min-height: 320px;
          }
          .cat-emoji {
            font-size: 52px;
          }
        }

        /* ── Small tablet: 640px – 900px ── */
        @media (max-width: 900px) {
          .cat-page {
            padding: 48px 20px 64px;
          }
          .cat-header {
            margin-bottom: 40px;
          }
          .cat-subtitle {
            font-size: 14px;
          }
          .cat-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 14px;
          }
          .cat-card {
            min-height: 300px;
          }
          .card-title {
            font-size: 13px;
          }
          .cat-emoji {
            font-size: 46px;
          }
        }

        /* ── Mobile: up to 640px — single column ── */
        @media (max-width: 640px) {
          .cat-page {
            padding: 40px 16px 56px;
            align-items: flex-start;
          }
          .cat-header {
            margin-bottom: 32px;
          }
          .cat-eyebrow {
            font-size: 11px;
            letter-spacing: 4px;
          }
          .cat-title {
            letter-spacing: 2px;
          }
          .cat-grid {
            grid-template-columns: 1fr;
            gap: 14px;
          }
          .cat-card {
            min-height: auto;
            flex-direction: row;
            align-items: stretch;
            border-radius: 14px;
          }

          /* Horizontal card layout on mobile */
          .card-bg, .card-overlay { border-radius: 14px; }

          .badge-wrap {
            display: none; /* hide in horizontal layout */
          }
          .corner-tl, .corner-br { display: none; }

          .emoji-wrap {
            flex: 0 0 90px;
            padding: 16px 8px;
          }
          .cat-emoji {
            font-size: 40px;
          }

          .lang-label {
            margin: 0 12px 0 0;
            align-self: flex-start;
            margin-top: 10px;
          }

          .card-bottom {
            flex: 1;
            padding: 14px 14px 14px 0;
            justify-content: space-between;
            gap: 8px;
          }
          .card-title {
            font-size: 13px;
          }
          .card-subtitle {
            -webkit-line-clamp: 1;
            font-size: 9px;
          }
          .play-btn {
            width: 36px; height: 36px;
          }
          .play-btn svg {
            width: 18px; height: 18px;
          }
        }

        /* ── Very small mobile: up to 380px ── */
        @media (max-width: 380px) {
          .emoji-wrap {
            flex: 0 0 72px;
          }
          .cat-emoji {
            font-size: 34px;
          }
          .card-title {
            font-size: 12px;
          }
          .count-badge {
            font-size: 10px;
            padding: 3px 9px;
          }
        }
      `}</style>
    </div>
  );
}